// React
import React, { useState, useEffect } from "react";

// Ionic
import { IonContent, IonPage, IonGrid, IonRow } from "@ionic/react";

// Components
import Profile from "../components/UserProfile/Profile";

//Data
import UserService from "../Context/user.service";


//CSS


var isProinitial = false;

const tokenData = UserService.getUserData();
if (typeof tokenData["tokenData"].MerchantCustomerId !== "undefined") {

    if (tokenData.pro == 1) {
        isProinitial = true;
    }
}

// Packages

function UserProfile(props) {
  const [user, setUser] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [token, setToken] = useState("");

  useEffect(() => {
    const userData = UserService.getUserData();

    if (
      typeof userData.tokenData.MerchantCustomerId !== "undefined" &&
      userData.tokenData.MerchantCustomerId != 0
    ) {
      //tokenData.MerchantCustomerId
      var pid = userData.tokenData.MerchantCustomerId;
      UserService.getProfileFields(pid, userData.cookie).then(
        (response) => {
          // fallback if no data online
          if (response.data.length === 0) {
            var user = {
              pid: pid,
              vehicle_type: "",
              vehicle_model: "",
              vehicle_brand: "",
              vehicle_length: "",
               more_vehiclebrand:"",
              crew: [],
              interests: [],
              age: "",
            };
          } else {
            var user = response.data[0];
          }
          setToken(userData.cookie);
          setUser(user);
          setIsLoggedIn(true);
          setIsLoaded(true);
        },
        (error) => {
          console.log(error);
        }
      );
    } else {
      setIsLoaded(true);
    }
  }, []);

  if (typeof window.parent.seturl !== "undefined") {
    window.parent.seturl("profil");
  }

  return isLoaded ? (
    <IonPage>
      <IonContent fullscreen>
        {(function () {
          if (isLoggedIn) {
            return <Profile user={user} token={token} />;
          } else {
            if (typeof window.parent.setPaywallModal !== "undefined") {
              window.parent.setPaywallModal("login");
            }

            return (
              <>
                <IonGrid className="ion-margin">
                  <IonRow size="12" className="ion-justify-content-center">
                    <h2>Profil</h2>
                  </IonRow>
                  <IonRow size="12" className="ion-justify-content-center">
                    <p>
                      {" "}
                      Bitte loggen Sie sich ein um diese Funktion zu nutzen.
                    </p>
                  </IonRow>
                </IonGrid>
              </>
            );
          }
        })()}
      </IonContent>
    </IonPage>
  ) : (
    <></>
  );
}

export default UserProfile;
